import BaseElement from './BaseElement';
import IconSet from '../Components/Mediathek/IconSet';
class IconSetElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = IconSet;
    }
}
export default IconSetElement;
